import React, { Component } from 'react';
import { Container, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';

const QUERY_GET_PROMOTIONS = gql`
  query {
    promotions {
      promotions {
        show
        enabled
        description
        termsAndConditions
      }
    }
  }
`;

const StyledPromotionBanner = styled.a`
    .promotion-alert {
      color: white;
      text-transform: uppercase;
      text-align: center;
      font-size: 0.8em;
      background-color: ${props => props.theme.promotion.backgroundColor};
      border-radius: 0.3125rem 0.3125rem 0 0; 
      height: 100%;
      position: relative;

      &.is-terms {
        &:hover,
        :focus,
        :active {
          background-color: ${props =>
            props.theme.promotion.backgroundHighlightColor};
        }
      }
      .vertically-centered {
        display: flex;
        justify-content: center;
        flex-direction: column;
        height: 100%;
        padding: 0.5em 0.75em;
        
        &.is-terms {
          &:hover,
          :focus,
          :active {
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
      p {
        font-weight: bold;
        font-size: 1.25em;
        margin: 0;
      }
    }
  }
`;

const PromotionModal = styled(Modal)`
  .close {
    color: white;
    opacity: 1;
  }

  .modal-content {
    border-radius: 0.25em;
    border: 0;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);

    h1 {
      color: ${props => props.theme.modal.headerColor};
    }
  }

  .modal-header {
    color: #fff;
    background: ${props => props.theme.modal.headerColor};

    .modal-title {
      width: 100%;
      text-align: center;
    }

    .promotion-terms-text {
      text-align: left;
    }
  }
`;

class PromotionBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPromotionModal: false
    };
  }

  togglePromotionModal = () => {
    const { showPromotionModal } = this.state;

    this.setState({
      showPromotionModal: !showPromotionModal
    });
  };

  render() {
    const { offers, offerError } = this.props;

    const { showPromotionModal } = this.state;

    return (
      <Query query={QUERY_GET_PROMOTIONS}>
        {({ loading, error, data }) => {
          if (loading) return null;

          const promotion =
            data && data.promotions && data.promotions.promotions
              ? find(data.promotions.promotions, p => p.show && p.enabled)
              : null;

          const hasTerms = promotion && !!promotion.termsAndConditions;

          const promotionTerms = hasTerms
            ? promotion && promotion.termsAndConditions
            : null;

          const showPromotion = promotion && offers && !offerError;

          if (!promotion) {
            return null;
          }

          const promotionDescription = promotion ? promotion.description : null;

          return (
            <React.Fragment>
              <StyledPromotionBanner
                onClick={
                  showPromotion && hasTerms ? this.togglePromotionModal : null
                }
              >
                <div
                  className={`promotion-alert ${
                    hasTerms && showPromotion ? 'is-terms' : ''
                  }`}
                >
                  <div
                    className={`vertically-centered ${
                      hasTerms && showPromotion ? 'is-terms' : ''
                    }`}
                  >
                    {showPromotion ? (
                      <React.Fragment>
                        BOOK ONLINE AND GET
                        <p>{promotionDescription}</p>
                      </React.Fragment>
                    ) : (
                      'Enter your player rewards info to be eligible for an award upon checkin'
                    )}
                  </div>
                </div>
              </StyledPromotionBanner>
              <PromotionModal
                isOpen={showPromotionModal}
                toggle={this.togglePromotionModal}
                backdrop={false}
                size="lg"
                autoFocus
                centered
              >
                <ModalHeader toggle={this.togglePromotionModal}>
                  TERMS AND CONDITIONS
                </ModalHeader>
                <ModalBody>
                  <Container fluid>
                    <Row>
                      <div className="promotion-terms-text">
                        {promotionTerms &&
                          promotionTerms.split('\n').map((item, key) => {
                            return (
                              <React.Fragment key={key}>
                                {item}
                                <br />
                              </React.Fragment>
                            );
                          })}
                      </div>
                    </Row>
                  </Container>
                </ModalBody>
              </PromotionModal>
            </React.Fragment>
          );
        }}
      </Query>
    );
  }
}

PromotionBanner.propTypes = {
  offers: PropTypes.object,
  offerError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export default PromotionBanner;
